// Preview-only fixture. Never ingest this as a real opportunity or publish it.
export const longReplyExample = {
  id: 'preview-long-reply', kind: 'reply', is_example: true, revision: 0,
  status: 'draft', author: '@workflow_demo · fictional author', priority: 'A',
  created_at: '2026-09-11T08:30:00+05:30',
  source_at: '2026-09-11T08:00:00+05:30', reply_by: '2026-09-12T08:00:00+05:30',
  impressions: 1505, likes: 7, replies: 16,
  category: 'Founder workflows', objective: 'Engagement',
  rationale: 'The author describes tool overload as a workflow problem. A specific reply about handoffs and review points adds to the conversation without pitching a product.',
  source_text: `We tried to fix our team's operations by adding more tools.
For a while, it felt like progress.

One tool captured meeting notes.
Another organized customer feedback.
A third drafted follow-up emails.
And a fourth tracked everything we forgot to do.

Each tool worked reasonably well on its own.
The gaps between them were the problem.

A customer would explain something important on a call.
The notes would land in one place.
The decision would happen in another.
The person writing the follow-up would miss both.

So we changed the question.
Instead of asking which tool we should buy next,
we asked what needed to happen after a customer conversation.

Who owns the next step?
What context do they need?
Where should a human review the output?
And how do we know the loop is actually closed?

That exercise helped more than another software trial.
We still use automation, but the handoffs come first.

What's one workflow your team simplified by removing a tool?`,
  posts: ['The gap between tools is where context gets lost. Mapping the owner, the handoff and the review point before adding automation feels like the right order. Did you end up removing a tool, or mostly changing how the team used the ones you already had?'],
};
